import { padStart as ps } from 'lodash';

export function padStart(value: number, length = 2, padStr = '0') {
  return ps(value.toString(), length, padStr);
}
